<template>
  <section class="corporate-training-page">
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/training">培训中心</router-link>
      <span class="separator">/</span>
      <span class="current">2026年度培训计划</span>
    </nav>

    <!-- ===== 01. Hero 区 ===== -->
    <section class="content" style="padding-top: 20px;">
      <div class="hero-gradient" style="border-radius: 24px; padding: 40px 28px;">
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 48px; align-items: center;">
          <!-- 左侧内容 -->
          <div>
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 24px;">
              <span class="cdo-badge secondary">工信部电子标准院 · 人才认证</span>
            </div>
            <h1 class="cdo-h1" style="color: white;"> 古杉数据2026年数字工程师培训<br>企业内训 &amp; 联合认证方案 </h1>
            <p style="color: rgba(255,255,255,0.85); font-size: 18px; max-width: 500px;"> 响应国家数字人才号召 · 数据/AI/素养 · 培训+实践+认证+评价一站式</p>
            
            <div class="cdo-keyword-cloud" style="margin: 20px 0 28px;">
              <h2 class="cdo-keyword-tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">工信部+电标院联合认证</h2>
              <h2 class="cdo-keyword-tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">企业内训</h2>
              <h2 class="cdo-keyword-tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">外部培训（线上&线下）</h2>
              <h2 class="cdo-keyword-tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">数据 + 分析 + AI</h2>
            </div>
            <div style="display: flex; gap: 20px;">
                <a href="#enroll" class="btn-primary" style="background: white; color: #0E1F52; border: none;">立即报名 <i class="fas fa-arrow-right"></i></a>
                <a href="#" class="btn-outline" style="border-color: white; color: white;">获取课程手册</a>
            </div>
          </div>
          <!-- 右侧抽象视觉 -->
          <div style="display: flex; justify-content: center;">
            <div style="width: 200px; height: 200px; background: rgba(255,255,255,0.08); border-radius: 50%; display: flex; align-items: center; justify-content: center; border: 2px solid rgba(255,255,255,0.2);">
              <i class="fas fa-user-tie" style="font-size: 120px; color: rgba(255,255,255,0.5);"></i>
            </div>
          </div>

        </div>
      </div>
    </section>
    

    <section class="content">
        <div class="section-title">2026年全系列课程 · 联合工信部（横线竖线清晰版）</div>
        <table class="course-grid">
          <thead>
            <tr>
              <th>业务领域</th>
              <th>课程方向</th>
              <th>课程名称</th>
              <th>优势 / 特色 / 认证</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="category-col" rowspan="10" style="vertical-align: middle;"> 数字化能力</td>
              <td rowspan="3">数据管理</td>
              <td><span class="course-name">数据分析</span> <span class="hot-badge">热门</span></td>
              <td class="feat-text">工信部颁发证书、终身有效、考试费低</td>
            </tr>
            <tr>
              <td><span class="course-name">数据治理</span> <span class="hot-badge">热门</span></td>
              <td class="feat-text">全球通用DAMA权威认证系列</td>
            </tr>
            <tr>
              <td><span class="course-name">首席数据官CDO实践课程（高端）</span> <span class="hot-badge">热门</span> <span class="joint-badge">联合电标院</span></td>
              <td class="feat-text">4位专业互补一线讲师，中高层/数据专业欢迎，实战性最强</td>
            </tr>
            <tr>
              <td rowspan="3">AI管理</td>
              <td><span class="course-name">人工智能训练师</span></td>
              <td class="feat-text">0基础可学，适合初级学员，部分地区有补助</td>
            </tr>
            <tr>
              <td><span class="course-name">AI标注工程师</span> <span class="joint-badge">联合电标院</span></td>
              <td class="feat-text">AI标注、标注管理</td>
            </tr>
            <tr>
              <td><span class="course-name">AI高端实践课程</span> <span class="new-badge">新课热</span></td>
              <td class="feat-text">MIT博士+一线科技公司AI从业者授课，强化AI风险/管理</td>
            </tr>
            <tr>
              <td>AIGC</td>
              <td><span class="course-name">AI大语言模型应用实战</span> <span class="new-badge">新课热</span></td>
              <td class="feat-text">大语言模型通识+自动文本/知识问答/分析专题，掌握技能</td>
            </tr>
            <tr>
              <td>数字素养培训</td>
              <td><span class="course-name">数据素养基础课程（初/中/高级）</span> <span class="hot-badge">热门</span></td>
              <td class="feat-text">非数据/IT人员必知必会、数据管理概念、职业发展</td>
            </tr>
            <tr>
              <td rowspan="3">数据+业务<br>（财务/供应链/审计）</td>
              <td><span class="course-name">数据分析在财务领域的分析实践应用</span></td>
              <td class="feat-text">数据必知必会、分析挖掘、财务业务规划、实战案例</td>
            </tr>
            <tr>
              <td><span class="course-name">数据分析在供应链领域的分析治理实践应用</span></td>
              <td class="feat-text">数据必知必会、供应链规划场景、治理实践</td>
            </tr>
            <tr>
              <td><span class="course-name">审计|风控|合规|财务|供应链</span></td>
              <td class="feat-text">大数据审计培训、自助分析建模、AI工具使用</td>
            </tr>
            <tr>
              <td class="category-col" style="vertical-align: middle;">🔄 数字化转型规划</td>
              <td>数字化转型</td>
              <td><span class="course-name">数字化转型实战认证</span></td>
              <td class="feat-text">工信部人才交流中心证书、终身有效、考试费低、完整方法论</td>
            </tr>
          </tbody>
        </table>

        <div class="feature-strip">
          <span>资深一线老师授课</span>
          <span>突出实践/技术落地</span>
          <span>前瞻性案例</span>
          <span>实践操作+评价监督</span>
        </div>

        <!-- 第二部分：案例展示（2025） -->
        <div class="section-title">2025 内训标杆案例</div>
        <div class="card-grid">
            <div class="case-card">
                <div class="case-header">
                    <span class="company">国家能源 · 财务共享</span>
                    <span class="tag">央国企</span>

                </div>
                <div class="dept">财务部门 · 160人 / 5天全封闭</div>
                <div class="desc">财务知识+数字化转型+数据分析+数字素养，分梯队培养复合型人才。考试后获工信部大数据分析师证书，满意度100%。</div>
                <div class="meta"><span>📅 2025.7</span><span>🏅 工信证书</span><span>📊 专家授课</span></div>
            </div>
            <div class="case-card">
                <div class="case-header">
                    <span class="company">Sensata · 供应链治理</span>
                    <span class="tag">外资</span>
                </div>
                <div class="dept">供应链+HR · 约50人 / 2天</div>
                <div class="desc">数据管理基础、数据治理、数据分析可视化，支撑大中华区数据战略，完成基础能力构建，满意度100%。</div>
                <div class="meta"><span>📅 2025.5</span><span>🔧 治理实践</span><span>🌍 全球战略</span></div>
            </div>
            <div class="case-card">
                <div class="case-header">
                    <span class="company">高能环境 · 财务+供应链</span>
                    <span class="tag">民营科技</span>
                </div>
                <div class="dept">信息部/财务/供应链 · 45人 /1天</div>
                <div class="desc">数据中台建成后，通过案例推动跨部门分析，运用AI工具构建预测分析，掌握商业分析报告能力。满意度100% 。</div>
                <div class="meta"><span>📅 2025.11</span><span>📈 AI预测</span><span>📊 workshop</span></div>
            </div>
        </div>

        <!-- CDO + AI 专项 -->
        <div style="display: flex; gap: 1.5rem; flex-wrap: wrap; margin: 2rem 0;">
            <div style="flex: 1; min-width: 250px; background: linear-gradient(145deg, #eef2ff, white); border-radius: 24px; padding: 1.8rem;">
                <h3 style="font-size: 1.6rem; font-weight: 700; margin-bottom: 0.5rem;">CDO实践班 <span style="font-size:0.9rem; background: #2563eb; color:white; padding: 0.2rem 1rem; border-radius: 30px; margin-left: 1rem;">联合工信部电标院</span></h3>
                <p style="margin: 0.8rem 0;">唯一侧重实践应用的CDO课程，4位一线导师，2025年已举办5期。学员来自央企/国企/外企数字总经理、数据负责人等。</p>
                <div style="background: #dbeafe; padding: 0.8rem; border-radius: 18px; margin-top: 1rem;">🔹 数字部门总经理  🔹 数据部主任  🔹 风控/财务  🔹 研究员</div>
            </div>
            <div style="flex: 1; min-width: 250px; background: linear-gradient(145deg, #f6f0ff, white); border-radius: 24px; padding: 1.8rem;">
                <h3 style="font-size: 1.6rem; font-weight: 700; margin-bottom: 0.5rem;"> AI及大模型实践</h3>
                <p>四大模块：AI应用基础、行业解决方案、模型优化、AIGC运营。真实案例+工具包，培养从技术到管理的全栈能力。</p>
                <div style="background: #ede2ff; padding: 0.8rem; border-radius: 18px; margin-top: 1rem;"> MIT博士/一线AI从业者授课 · 强化风险管理</div>
            </div>
        </div>
        
        
        
        
        <hr>
        <div style="display: flex; gap: 2rem; flex-wrap: wrap; justify-content: space-between; font-size: 0.98rem;">
          <div><span style="font-weight:700;">📌 2025内训标杆</span> 国家能源·财务160人 / Sensata供应链50人 / 高能环境45人 | 100%满意</div>
          <div><span style="font-weight:700;">📘 CDO实践班</span> 5期 央企/国企/外企数据负责人</div>
          <div><span style="font-weight:700;">🤖 AI大模型</span> 四大模块 MIT博士/一线专家</div>
        </div>
        <hr>

        <div class="about-block">
          <h3 style="font-size: 1.8rem; font-weight: 700; color: #0d2d4b;"> 北京古杉数据 · 联合工信部</h3>
          <p style="font-size: 1rem; margin-top: 0.8rem;">成立于2017年，核心团队来自IBM、Mars、微软。数字化咨询+AI教育，已服务国家电网、国家能源、浪潮信息、Sensata、高能环境等。师资为一线技术管理实践专家+财务/审计/数字化咨询专家。</p>
          <div style="background: #cedffb; padding: 0.5rem 2rem; border-radius: 40px; display: inline-block; margin-top: 1rem; border:1px solid #4870b0;">✅ 工信部电子标准院 · 人才交流中心 双认证</div>
        </div>

        <div class="contact-block">
          <div>
            <div style="font-size: 1.2rem; opacity: 0.9; color: black;">课程班主任（获取详细内训方案）</div>
            <div class="phones" style="font-size: 1.3rem; margin-top: 0.3rem; color: black;">桑老师 173-9317-3801</div>
            <div class="phones" style="font-size: 1.3rem; margin-top: 0.3rem; color: black;">顾老师 130-5116-8825</div>
            <div style="margin-top: 1rem; background: #1a5588; width: fit-content; padding: 0.3rem 2rem; border-radius: 40px;">一对一咨询 · 定制内训</div>
          </div>
          <div class="qr-duo">
            <div class="qr-item">
              <img src="@/assets/img/qr_sang.jpg" alt="qr">
              <span>扫码报名</span>
            </div>
            <div class="qr-item">
              <img src="@/assets/img/qr_shequ.jpg" alt="社群">
              <span>数据决策社群</span>
            </div>
          </div>
        </div>

        <div class="footer-note">
          * 全系列课程：数据分析 · 数据治理 · CDO · AI训练师/标注/高端实践 · 大模型 · 数据素养 · 财务/供应链/审计数字化 · 数字化转型认证 · 联合工信部颁发证书 *
        </div>
    </section>


  </section>
</template>

<script>
export default {
  name: 'TrainingDetailCorporateTraining'
}
</script>

<style scoped>

.corporate-training-page {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  background-color: #ffffff;
  color: #1e2a3a;
  line-height: 1.6;
}




/* 标题样式 */
h1, .cdo-h1 {
  font-size: 42px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--deep-indigo);
  margin-bottom: 24px;
}

h2, .container {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 32px;
  color: var(--deep-indigo);
  letter-spacing: -0.01em;
  position: relative;
}

.container i {
  margin-right: 12px;
  color: var(--accent-blue);
}

h3, .cdo-h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: var(--deep-indigo);
}

h4, .cdo-h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--text-dark);
}

p, li {
  font-size: 16px;
  color: var(--text-dark);
  margin-bottom: 16px;
}

.cdo-subhead {
  font-size: 18px;
  color: var(--cdo-text-gray);
  line-height: 1.7;
  margin-bottom: 20px;
}


/* 徽章 */
.cdo-badge {
  display: inline-block;
  background: var(--accent-blue);
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  margin-right: 10px;
}

.cdo-badge.secondary {
  background: #10b981;
}




/* 面包屑导航 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 24px 10px;
  font-size: 14px;
  color: var(--cdo-text-gray);
}

.breadcrumb-nav a {
  color: var(--cdo-accent-blue);
  text-decoration: none;
  transition: color 0.2s;
}

.breadcrumb-nav a:hover {
  color: #0E1F52;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #cbd5e1;
}

.breadcrumb-nav .current {
  color: var(--cdo-text-dark);
  font-weight: 500;
}



/* 容器 */
.section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

.section:last-child {
  margin-bottom: 0;
}

/* 课程展示样式*/
.card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.8rem;
    margin-bottom: 2rem;
}


.case-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid #e9eef3;
    transition: all 0.3s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.02);
    cursor: pointer;
}
.case-card:hover {
    border-color: black;
    transform: translateY(-6px);
    box-shadow: 0 24px 40px rgba(31,63,143,0.12);
}




.case-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
}
.company {
    font-weight: 700;
    font-size: 1.2rem;
    color: #1e3a5f;
}

/*     background: #2563eb;*/
.tag {
    background:#D4AF37;   
    color: white;
    padding: 0.2rem 1rem;
    border-radius: 30px;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.3px;
    margin-left: 1rem;
}

.dept {
    color: #4b5563;
    font-size: 0.9rem;
    margin: 0.5rem 0 0.75rem;
    border-bottom: 1px dashed #d1d9e6;
    padding-bottom: 0.6rem;
}
.desc {
    color: #2d3a4b;
    font-size: 0.95rem;
    margin-bottom: 1rem;
}
.meta {
    display: flex;
    gap: 1rem;
    font-size: 0.85rem;
    color: #4f6f8f;
    background: white;
    border-radius: 30px;
    padding: 0.4rem 0.9rem;
    width: fit-content;
    border: 1px solid #dde7f0;
}
.meta span {
    display: flex;
    align-items: center;
    gap: 0.2rem;
}

/* Hero特殊渐变 */
.hero-gradient {
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
  color: white;
}



/* 标签组与关键词云 */
.tag-group, .cdo-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 20px 0 28px;
}

.cdo-keyword-tag {
  display: inline-block;
  background: rgba(31,63,143,0.05);
  color: #0E1F52;
  padding: 8px 20px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(31,63,143,0.2);
  transition: all 0.2s;
}

.cdo-keyword-tag:hover {
  background: var(--accent-blue);
  color: white;
  transform: translateY(-2px);
}

.cdo-keyword-tag.highlight {
  background: var(--accent-blue);
  color: white;
  border-color: var(--accent-blue);
}


/* 按钮风格 */
.cdo-btn, .btn-primary, .btn-outline {
  display: inline-block;
  padding: 14px 36px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  cursor: pointer;
  letter-spacing: 0.5px;
}


.page {
  max-width: 1360px;
  margin: 0 auto;
  background: white;
  border-radius: 36px;
  box-shadow: 0 30px 60px -15px rgba(7, 30, 55, 0.3);
  overflow: hidden;
}
/* 页头 */
.hero {
  background: linear-gradient(155deg, #082338 0%, #193d62 100%);
  padding: 2.4rem 3rem;
  color: white;
  border-bottom: 6px solid #2970d9;
}
.hero h1 {
  font-size: 2.9rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin-bottom: 0.5rem;
}
.hero .badge {
  background: #2970d9;
  padding: 0.3rem 1.4rem;
  border-radius: 40px;
  font-weight: 600;
  font-size: 1rem;
  display: inline-block;
  margin-bottom: 1rem;
  border: 1px solid rgba(255,255,255,0.3);
}
.hero .sub {
  font-size: 1.25rem;
  font-weight: 300;
  color: #cde1ff;
  max-width: 70%;
}
.content {
  padding: 2.5rem 3rem 3rem;
}
.section-title {
  font-size: 2.2rem;
  font-weight: 700;
  margin: 2rem 0 1.5rem 0;
  border-left: 12px solid #2970d9;
  padding-left: 1.5rem;
  color: #092844;
}
.section-title:first-of-type {
  margin-top: 0;
}

/* ----- 核心表格：横线竖线清晰（全部边界可见）----- */
.course-grid {
    border-collapse: collapse;
    width: 100%;
    font-size: 0.96rem;
    box-shadow: 0 5px 15px rgba(0, 30, 60, 0.05);
    background: white;
    border: 1px solid #b4c8e2;
    border-radius: 20px;
    overflow: hidden;
    margin: 1.8rem 0 2.2rem;
}
.course-grid th {
    background-color:#2A7DE1;
    color: white;
    font-weight: 600;
    font-size: 1rem;
    padding: 1rem 1.2rem;
    text-align: left;
    border: 1px solid #2b5580;
    border-bottom: 2px solid #688fc7;
}
.course-grid td {
  padding: 1rem 1.2rem;
  background-color: white;
  border: 1px solid #b0c7e7;
  vertical-align: top;
}
/* 分类列底色 */
.category-col {
  background-color: #e9f3f2 !important;
  font-weight: 700;
  color: #0b3155;
  border-right: 2px solid #6e96cf;
}
/* 课程名称醒目 */
.course-name {
  font-weight: 600;
  color: #0a2f54;
}
.hot-badge {
  background: #c6362a;
  color: white;
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.25rem 0.9rem;
  border-radius: 40px;
  margin-left: 0.6rem;
  display: inline-block;
  white-space: nowrap;
}
.new-badge {
  background: #dD7c1b;
  color: white;
  font-size: 0.68rem;
  font-weight: 700;
  padding: 0.25rem 0.9rem;
  border-radius: 40px;
  margin-left: 0.6rem;
  display: inline-block;
}
.joint-badge {
  background: #1c6090;
  color: white;
  font-size: 0.68rem;
  padding: 0.25rem 0.8rem;
  border-radius: 40px;
  margin-left: 0.5rem;
  white-space: nowrap;
  font-weight: 500;
}
.feat-text {
  color: #1e4062;
  line-height: 1.4;
}

/* 特色标签行 */
.feature-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin: 1rem 0 2rem;
}
.feature-strip span {
  background: #e2edff;
  border: 1px solid #99b9e9;
  color: #03337a;
  padding: 0.4rem 1.5rem;
  border-radius: 40px;
  font-weight: 500;
  font-size: 0.95rem;
}

/* 公司区块 */
.about-block {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 30px;
  padding: 2rem 2.4rem;
  margin: 2.5rem 0;
}

/* 联系方式 */
.contact-block {
  background: #F6F8FC;
  border-radius: 40px;
  padding: 2.2rem 3rem;
  color: #e2e8f0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 2.8rem;
  border: #f8fafc;
}
.phones {
  font-size: 1.5rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.phones span {
  font-size: 0.95rem;
  font-weight: 300;
  color: #b8d6ff;
}
.qr-duo {
  display: flex;
  gap: 1.8rem;
}
.qr-item {
  background: white;
  border-radius: 26px;
  padding: 0.8rem 1.2rem;
  text-align: center;
  color: #1e293b;
  min-width: 120px;
  border: 1px solid #cccccc;
}
.qr-item img {
  width: 64px;
  height: 64px;
  background: #d0dae8;
  border-radius: 16px;
  margin-bottom: 0.3rem;
}

.footer-note {
  background: #e1edfc;
  text-align: center;
  padding: 1.2rem;
  color: #1f4b7a;
  font-size: 0.9rem;
  border-top: 2px solid #b3c9e7;
  margin-top: 2rem;
}

/* 小分隔线等 */
hr {
  border: none;
  border-top: 2px solid #c1d6f0;
  margin: 1.5rem 0;
}
</style>
